<template>
   <div id="bypass">
   </div>
</template>

<script>
import * as authService from "./services/auth.service";

export default {
    data() {
        return {
        };
    },
    created: function() {
        var obj = {};
        obj["uid"] = this.$route.params.uid;
        authService.authBylogin(JSON.stringify(obj)).then(response => {
            if (response.data.accessToken != null) {
                this.$store.state.token = response.data.accessToken;
                localStorage.setItem('redi', response.data.urlRedirect);
                localStorage.setItem("token", response.data.accessToken);
            }
            this.$router.push("/dashboard" + response.data.urlRedirect);
        });
    },
}
</script>

<style>

</style>